module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Metadado"},"en-US":{"title":"Metadata"}}')
  delete Component.options._Ctor
}
